import { createContext } from 'react';

type ContextType = {
    updateCSSVariables: (isResize?: boolean) => void;
};
const initialContextData: ContextType = {
    updateCSSVariables: () => {
        throw new Error('updateCSSVariables function is not initialized');
    },
};
export const TabsContext = createContext<ContextType>(initialContextData);
